import _ from 'lodash';
import {
  UPDATE_APP_SETTINGS_REQUEST,
  UPDATE_APP_SETTINGS_SUCCESS,
  UPDATE_APP_SETTINGS_ON_STORE,
} from '../actions/update-app-settings';
import { FETCH_APP_SETTINGS_SUCCESS } from '../actions/fetch-app-settings';

export default (state = {}, action = {}) => {
  switch (action.type) {
    case UPDATE_APP_SETTINGS_REQUEST:
    case UPDATE_APP_SETTINGS_SUCCESS:
    case UPDATE_APP_SETTINGS_ON_STORE:
    case FETCH_APP_SETTINGS_SUCCESS:
      return _.merge({}, state, action.payload);
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/app-settings.js